export const imageUrl = 'https://ethiodererp.com/api/images/save/product/'
export const viewImageUrl = 'https://ethiodererp.com/images/'